export const previousAlertState = {
  alertFilter: "All",
  dateFilter: "All",
  selectedAlert: null,
  openPdfModal: false,
};
